import React from 'react';

const ContentSettingsPage = () => {
  return <div>ContentSettingsPage</div>;
};

export default ContentSettingsPage;
